import ngramSimilarity from './ngramSimilarity'
import jaroWinklerSimilarity from './jaroWinklerSimilarity'

/**
 * Advanced acronym matching with partial and fuzzy support
 */
const calculateAcronymScore = (query, target) => {
  const words = target.toLowerCase().split(/\s+/).filter(word => word.length > 0)
  if (words.length === 0) return 0

  const queryLower = query.toLowerCase()
  let score = 0
  let queryIndex = 0

  // Strategy 1: Perfect acronym match (jucor -> j.c.)
  let perfectAcronym = ''
  for (const word of words) {
    if (word.length > 0) perfectAcronym += word[0]
  }

  if (queryLower === perfectAcronym) return 0.95

  // Strategy 2: Fuzzy acronym with Jaro-Winkler
  const acronymSimilarity = jaroWinklerSimilarity(queryLower, perfectAcronym)
  if (acronymSimilarity > 0.7) {
    score = Math.max(score, acronymSimilarity * 0.8)
  }

  // Strategy 3: Progressive matching (jucor -> ju.cor., j.cor., etc.)
  for (let wordIndex = 0; wordIndex < words.length && queryIndex < queryLower.length; wordIndex += 1) {
    const word = words[wordIndex]
    const remainingQuery = queryLower.slice(queryIndex)

    // Try initial match
    if (word[0] === queryLower[queryIndex]) {
      queryIndex += 1
      // eslint-disable-next-line no-continue
      continue
    }

    // Try prefix match for remaining query
    const maxPrefix = Math.min(remainingQuery.length, word.length)
    let prefixMatch = 0

    for (let i = 0; i < maxPrefix; i += 1) {
      if (remainingQuery[i] === word[i]) {
        prefixMatch += 1
      } else {
        break
      }
    }

    if (prefixMatch >= 2) {
      queryIndex += prefixMatch
    }
  }

  const coverage = queryIndex / queryLower.length
  if (coverage >= 0.6) {
    score = Math.max(score, coverage * 0.75)
  }

  // Strategy 4: N-gram based acronym similarity
  const ngramScore = ngramSimilarity(queryLower, perfectAcronym)
  if (ngramScore > 0.5) {
    score = Math.max(score, ngramScore * 0.6)
  }

  return score
}

export default calculateAcronymScore
